// extracted by mini-css-extract-plugin
export default {"container":"AdminSidebar_container__w84CB","profile":"AdminSidebar_profile__vKTQN","menuWrapper":"AdminSidebar_menuWrapper__GOLM4","item":"AdminSidebar_item__W-xhL"};